import React, { useState, useEffect } from 'react'
import { Button, ListGroup, Modal, Row, Col, Form } from 'react-bootstrap'
import { ArrowRightShort } from "react-bootstrap-icons";
import './styleToHtmlFile.css'

function ModalSelectDate(props) {
  // const [hoverDate, setHoverDate] = useState(false);
  const [isDaySelect, setIsDaySelect] = useState(props.defaultDate);
  const handlClose = () => {
    props.callBack();
  }

  var daysOfweek = ['یک شنبه', 'دو شنبه', 'سه شنبه', 'چهار شنبه', 'پنج شنبه', 'جمعه', 'شنبه'];
  var farsiToday = new Date().toLocaleDateString('fa-IR', { year: 'numeric', month: '2-digit', day: '2-digit' });
  var day = new Date().getDay();


  const [thirtDays, setThirtyDays] = useState([{
    date: farsiToday,
    day: daysOfweek[day],
    key: new Date()
  }])



  useEffect(() => {

    for (let i = 1; i < 30; i++) {
      getDateXDayafter(5)
      setThirtyDays((olderList) => [...olderList, { day: daysOfweek[getDateXDayafter(i).getDay()], date: getDateXDayafter(i).toLocaleDateString('fa-IR', { year: 'numeric', month: '2-digit', day: '2-digit' }), key: getDateXDayafter(i) }])
    }
  }, [])

  const getDateXDayafter = (numOfDays) => {
    const date = new Date()
    const daysAgo = new Date(date.getTime());
    daysAgo.setDate(date.getDate() + numOfDays);
    return daysAgo;
  }

  const handleSelect = (item) => {
    setIsDaySelect(item.date)
    props.callBack2(item)
    handlClose()
  }


  return (
    <>

      <Modal show={true} onHide={handlClose} className=' modal-dialog-scrollable     d-flex pr-4 ' centered >
        <Modal.Header>
          <Modal.Title className=''><p className='  my-0 py-0 cursor-pointer' onClick={handlClose}><ArrowRightShort size={22} /></p><p className=' mr-4 mt-0 pt-0'>تاریخ استفاده را انتخاب نمایید</p></Modal.Title>
        </Modal.Header>
        <Modal.Body className=' ' style={{ width: '250px' }}>
          <Form>
            <ListGroup variant='flush ' className='bg-white ' >
              {thirtDays.map((item, index) =>
                <ListGroup.Item key={index} onClick={() => handleSelect(item)} className=' px-0  bg-hover-light-blue rounded' style={item.date === isDaySelect ? { backgroundColor: '#cdeeee' } : {}}  >

                  <Row className='  m-0 p-0   d-flex w-100 justify-content-between cursor-pointer'>
                    {/* <Col xs="auto" className=" p-0 pr-2 d-flex align-items-center">
                                            <input
                                                onChange={() => handleSelect(item)}
                                                type="radio"
                                                className="radio  option-input  "
                                                checked={item.date === isDaySelect ? true : false}
                                            />
                                        </Col> */}
                    <Col>

                      <p className={item.key.getDay() === 5 ? 'text-danger w-100 p-0 mx-0  d-flex justify-content-between ' : 'w-100 p-0  mx-0 d-flex justify-content-between'}   >
                        <span>{item.day}</span>
                        <span>{item.date}</span>

                      </p>
                    </Col>

                  </Row>



                </ListGroup.Item>)}
            </ListGroup>
          </Form>

        </Modal.Body>
        <Modal.Footer>
          <Button variant='danger' size='sm' onClick={handlClose} className='px-3 d-flex align-items-center py-1 font-weight-bold'> <small>بستن </small></Button>
        </Modal.Footer>

      </Modal>




    </>
  )
}

export default ModalSelectDate